<div class="field">
    <mat-form-field
        [appearance]="appearance"
        [ngClass]="{'field-error': hasError}"
        [ngClass]="{'disabled' : control?.disabled}"
    >
        <mat-label>{{ label }}</mat-label>
        <input
            matInput 
            autocomplete="off"
            (focus)="touched = true"
            (blur)="checkErrors($event)"
            (keydown)="keyRestrictionFunction && keyRestrictionFunction($event)"
            (keyup)="inputChanged(); applyKeyRestriction($event)"
            [type]="inputType"
            [formControl]="control"
            [placeholder]="placeholder"
            [maxLength]="maxLength"
            (paste)="preventPaste($event)"
        />
    </mat-form-field>
    <span class="error-msg" *ngIf="hasError">{{ errorMessage }}</span>
    <img *ngIf="showImage" class="validation-img" [src]="image" />
</div>